// extracted by mini-css-extract-plugin
export default {"cardWrapper":"styles_cardWrapper__TyZPY","showCheckboxesWrapper":"styles_showCheckboxesWrapper__npKFc","paginationWrapper":"styles_paginationWrapper__iBjRu"};